import React from "react";
import "./contact.scss";
import * as Icon from 'react-feather';

const Contact = (props) => (
    <div id="contact-wrapper">
        <div id="contact" className="container">
            <span className="contact__question">Haben Sie Fragen?</span>
            <span className="contact__phone"><span className="contact__phone--icon"><Icon.Phone size={18}/></span><a
                href="tel:091316879760">09131 / 68 79 760</a></span>
            <span className="contact__mail"><span className="contact__mail--icon"><Icon.Mail size={12}/></span><a
                href="mailto:willkommen@sib-immobilien">willkommen@sib-immobilien</a></span>
        </div>
    </div>
)

export default Contact;



// WEBPACK FOOTER //
// ./src/contact/contact.js